<template>
  <div>
    <liquor-tree ref="tree" :key="componentKey" class="card mb-g" :data="tree" :options="options">
      <span slot-scope="{ node }" style="width:100%" class="tree-text tree-item">
        <span class="tree-item__first-element" :class="{ 'font-weight-bold': node.data.isAssigned }">{{
          node.text
        }}</span>

        <span>
          <check-permission entity-type="profile" permissions="USER.ROLE_MANAGE" :entity-id="$route.params.profileId">
            <button
              v-if="node.data.isAssigned"
              aria-label="Odbierz rolę"
              class="btn btn-lg btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 btn-delete"
              @click.stop="showDeleteDialog(node.id)"
            >
              <i :style="{ color: DELETE_ACTION.color }" :class="DELETE_ACTION.icon" />
            </button>

            <button
              v-else
              aria-label="Przyznaj rolę"
              class="btn btn-lg btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 btn-add"
              @click.stop="showAddDialog(node.id)"
            >
              <i :style="{ color: ADD_ACTION.color }" :class="ADD_ACTION.icon" />
            </button>
          </check-permission>
        </span>
      </span>
    </liquor-tree>
  </div>
</template>

<script>
import LiquorTree from 'liquor-tree';
import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { notificationsMixin } from '@/mixins/notifications';
import { ADD_ACTION, DELETE_ACTION } from '@/utils/constants';
import { buildTree } from '@/utils/tree';

// @vuese
// Lista ról użytkownika
// @group Profile
export default {
  components: {
    LiquorTree
  },
  mixins: [notificationsMixin],
  data() {
    return {
      options: {
        checkbox: false,
        propertyNames: {
          text: 'name'
        }
      },
      DELETE_ACTION,
      ADD_ACTION,
      componentKey: 0
    };
  },
  computed: {
    ...mapState({
      tree(state) {
        const userRoles = state.profile.roles.list;

        const roles = state.role.list.map(role => ({
          ...role,
          data: {
            isAssigned: userRoles.some(userRole => userRole.id === role.id)
          },
          state: { expanded: true, selectable: false }
        }));
        return buildTree(roles);
      }
    })
  },
  watch: {
    '$store.state.profile.roles.list'(val) {
      this.forceUpdate();
    }
  },
  methods: {
    // @vuese
    // Pokazuje dialog potwierdzający usunięcie roli
    showDeleteDialog(roleId) {
      this.$store.commit('showConfirm', {
        title: 'Usuwanie',
        description: 'Czy napewno chcesz odebrać użytkownikowi rolę?',
        onSuccess: () => this.remove(roleId)
      });
    },
    // @vuese
    // Pokazuje dialog potwierdzający dodanie roli
    showAddDialog(roleId) {
      this.$store.commit('showConfirm', {
        title: 'Dodawanie',
        description: 'Czy napewno chcesz przyznać rolę użytkownikowi?',
        onSuccess: () => this.add(roleId)
      });
    },
    // @vuese
    // Usuwa rolę użytkownikowi
    remove(roleId) {
      this.$store
        .dispatch('profile/roles/remove', roleId)
        .then(() => this.notifySuccess(Successes.ROLE_REVOKED))
        .catch(() => this.notifyError(Errors.ROLE_CANNOT_REVOKE));
    },
    // @vuese
    // Dodaje rolę do użytkownika
    add(roleId) {
      this.$store
        .dispatch('profile/roles/add', roleId)
        .then(() => this.notifySuccess(Successes.ROLE_GRANTED))
        .catch(() => this.notifyError(Errors.ROLE_CANNOT_GRANT));
    },
    // @vuese
    // Odświeża drzewo
    forceUpdate() {
      this.componentKey++;
    }
  }
};
</script>
